export const MATCH_OPTIONS = [
    {
        value: 'any',
        label: 'Any',
    },
    {
        value: 'busy',
        label: 'Busy',
    },
    {
        value: 'free',
        label: 'Free',
    },
];

export default {
    MATCH_OPTIONS,
};

export const MAX_STRING_LENGTH = 24;
